<template>
  <div class="bg-white rounded shadow-sm border">
    <div class="px-5 pt-5">
      <div class="mb-5">
        <slot />
      </div>
    </div>

    <slot name="buttons" />
  </div>
</template>
